<div class="container">
  <div class="main-div">
    <div class="center-pane">
      <div class="form-div">
        <div class="header">
          <div class="logo">
            <img src="assets/logo-full.svg"/>
          </div>
          <h2 i18n="@@merchantForgotPasswordTitle">Forgot password</h2>
          <p i18n="@@merchantForgotPasswordSubtitle">Enter your e-mail address. You will receive a link to reset your password.
          </p>
        </div>
        <!-- emailItem -->
        <input-text-field (onchange)="updateInputFieldById('email', $event)"
                          [errorHandling]="errorHandling"
                          [floatingLabel]="emailLabel"
                          [group]="signInForm"
                          [id]="'email'"
                          [inputType]=InputType.email
                          [validators]=[Validators.required,Validators.email]
        ></input-text-field>

        <div *ngIf="serverError !== null"
             class="alert alert-danger form-alert">{{ serverError }}</div>


        <div class="button-container">
          <primary-button
            (onClick)="onResetSubmitted()"
            [loading]="isLoading"
            [title]="resetPassword">
          </primary-button>

          <secondary-button
            (onClick)="onLoginClicked()"
            [title]="backToLoginLabel">
          </secondary-button>
        </div>

      </div>
    </div>
  </div>
</div>
